import {
  UIComponentErrorMessages,
  DateUtilsErrorMessages,
} from "./ui-component-error-messages.constants.js";

export class PresentationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "PresentationError";
  }
}

export class UIComponentContextError extends PresentationError {
  constructor(
    public readonly componentName: string,
    public readonly requiredContext: string,
  ) {
    super(
      UIComponentErrorMessages.MISSING_CONTEXT(componentName, requiredContext),
    );
    this.name = "UIComponentContextError";
  }
}

export class TimezoneOffsetError extends PresentationError {
  constructor(public readonly timezone: string) {
    super(DateUtilsErrorMessages.TIMEZONE_OFFSET_NOT_FOUND(timezone));
    this.name = "TimezoneOffsetError";
  }
}
